import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const constructionValidationSchema = Yup.object({
  constructionBuildingProcedure: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  buildingPurpose: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  requirementGroup: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  constructionCommencement: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  buildingTypeNationalClassification: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  accessibilityRating: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  greenInfrastructureType: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
});

export const constructionValidationV2Schema = Yup.object({
  constructionBuildingProcedure: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  buildingPurpose: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  requirementGroup: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
});
